import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// TODO leave for now. Once everything is finished, check if this is needed
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
